import { createRequiredContext } from '@klokhuis/utilities/RequiredContext';

import { IntlObject } from './types';

export const IntlContext = createRequiredContext<IntlObject>('IntlContext');
